import {DeleteOutlined, PlusOutlined} from '@ant-design/icons';
import {Button, Form, Input, InputNumber, Modal, Select, Space} from 'antd';
import PropTypes from 'prop-types';

const ProductEditScreen = ({editModal,
  setEditModal,
  form,
  updateProductMutation,
  token,
  imageFiles,
  setImageFiles,
  dataSource,
  setDataSource,
  handleChange}) =>{

  return(
  //TEST COMMIT 

    <div>
      <Modal
        title={'Edit Product'}
        open={editModal.visible}
        // open={editModal?.visible}
        onCancel={() => setEditModal({visible: false, record: null})}
        onOk={() => form.submit()}
        okText={'Update Product'}
        confirmLoading={updateProductMutation.isLoading}
      >
        <Form
          form={form}
          layout={'vertical'}
          onFinish={values => {
            const updatedProduct = {
              ...editModal.record,
              ...values,
              imageUrl: imageFiles,
              weight: {
                grossWeight: values.grossWeight,
                netWeight: values.netWeight,
              },
            };

            const formData = new FormData();

            formData.append(
              'command',
              new Blob([JSON.stringify(updatedProduct)], {
                type: 'application/json',
              }),
            );
            
            imageFiles.forEach(file => {
              formData.append('images', file);
            });

            updateProductMutation.mutate({
              token,
              id: editModal.record.id,
              formData: formData,  
            });

            setEditModal({visible: false, record: null});
            setImageFiles([]);
          }}
        >
          <Form.Item name={'productName'} label={'Product Name'} rules={[{required: true}]}>
            <Input />
          </Form.Item>
          <Form.Item name={'description'} label={'Description'} rules={[{required: true}]}>
            <Input.TextArea rows={3} />
          </Form.Item>
          <div className={'flex justify-between gap-2'}>
            <Form.Item
              className={'w-1/2'}
              name={'jewelryType'}
              label={'Jewelry Type'}
              rules={[{required: true, message: 'Please enter jewelry type'}]}
            >
              <Select
                defaultValue={'lucy'}
                // style={{width: 120}}
                onChange={handleChange}
                options={[
                  {value: 'GOLD', label: 'Gold'},
                  {value: 'SILVER', label: 'Silver'},
                  {value: 'IMITATION', label: 'Imitation'},
                ]}
              />
            </Form.Item>
            <Form.Item
              className={'w-1/2'}
              name={'productType'}
              label={'Product Type'}
              rules={[{required: true, message: 'Please enter product type'}]}
            >
              <Input />
            </Form.Item>
          </div>
          <div className={'flex justify-between gap-2'}>
            <Form.Item
              className={'w-1/2'}
              name={'grossWeight'}
              label={'Gross Weight'}
              rules={[{required: true, message: 'Please enter gross weight'}]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              className={'w-1/2'}
              name={'netWeight'}
              label={'Net Weight'}
              rules={[{required: true, message: 'Please enter net weight'}]}
            >
              <Input />
            </Form.Item>
          </div>
          <Form.List name={'size'}>
            {(fields, {add, remove}) => (
              <>
                <p className={'block font-medium mb-1'}>
        Size, Quantity & Price
                </p>

                {fields.map(({key, name, ...restField}) => (
                  <Space key={key} align={'baseline'}>

                    <Form.Item
                      {...restField}
                      name={[name, 'size']}
                      rules={[{required: true}]}
                    >
                      <Input placeholder={'Size'} />
                    </Form.Item>

                    <Form.Item
                      {...restField}
                      name={[name, 'quantity']}
                      rules={[{required: true}]}
                    >
                      <InputNumber min={1} placeholder={'Qty'} />
                    </Form.Item>

                    <Form.Item
                      {...restField}
                      name={[name, 'price']}
                      rules={[{required: true}]}
                    >
                      <InputNumber min={0} placeholder={'Price'} />
                    </Form.Item>

                    <Button danger onClick={() => remove(name)}>
                      <DeleteOutlined />
                    </Button>

                  </Space>
                ))}

                <Button type={'dashed'} onClick={() => add()}>
        Add Size
                </Button>
              </>
            )}
          </Form.List>
          {/* <Form.Item name={'price'} label={'Price'} rules={[{required: true}]}>
            <Input type={'number'} />
          </Form.Item> */}
        </Form>
      </Modal>
    </div>
  );
};

ProductEditScreen.propTypes = {
  editModal: PropTypes.shape({
    visible: PropTypes.bool.isRequired,
    record: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      imageUrl: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string),
      ]),
      productName: PropTypes.string,
      jewelryType: PropTypes.string,
      productType: PropTypes.string,
      grossWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      netWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      description: PropTypes.string,
      createdOn: PropTypes.string,
      size: PropTypes.arrayOf(
        PropTypes.shape({
          size: PropTypes.string,
          quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

        }),
      ),
    }),
  }).isRequired,

  setEditModal: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  token: PropTypes.string.isRequired,

  imageFiles: PropTypes.arrayOf(PropTypes.string).isRequired,
  setImageFiles: PropTypes.func.isRequired,

  dataSource: PropTypes.array.isRequired,
  setDataSource: PropTypes.func.isRequired,

  updateProductMutation: PropTypes.shape({
    mutate: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
  }).isRequired,

  handleChange: PropTypes.func.isRequired,
};

export default ProductEditScreen;
